import { motion } from 'framer-motion'

// All path "d" data extracted from the original NE Group logo SVG.
const PATHS = [
  // "N" mark
  'm0,.05v200.09h200.1V.05H0Zm188.73,188.48h-114.32v-115.82h-12.03v115.82H11.99V11.54h114.57v122.09h12.03V11.54h50.14v176.99Z',
  // "E" mark
  'm212.54,0v200.2h199.82V0h-199.82Zm188.16,68.52h-119.58v12.03h119.58v45.37h-119.58v12.03h119.58v50.39h-176.74V11.62h176.74v56.91Z',
  // GAMES letters
  'm46.14,224.98c-18.07,0-32.23,14.12-32.23,32.15s14.16,32.23,32.23,32.23c9.37,0,17.89-3.8,24-10.69,5.69-6.43,8.53-14.89,7.91-23.42h-34.58v8.51h20.02l-.78,2.24c-2.27,6.55-9.15,11.12-16.73,11.12-11.4,0-19.67-8.31-19.67-19.75s8.53-19.75,19.83-19.75c6.24,0,11.95,3.17,14.87,8.16l15.13-.06c-4.59-12.49-16.38-20.73-30-20.73Z',
  'm146.16,288.05h12.71l-22.17-61.84h-14.12l-22.54,61.84h13.1l2.69-8.08h27.63l2.69,8.08Zm-5.7-17.15h-21.62l10.81-32.83,10.81,32.83Z',
  'm246.1,288.05h12.55v-61.84h-18.14l-17.56,47.43-17.82-47.43h-18.3v61.84h12.55v-46.19l17.51,46.19h11.86l17.35-45.7v45.7Z',
  'm291.84,288.05h33.87v-11.76h-21.32v-15.26h19.49v-8.51h-19.49v-14.62h21.32v-11.6h-33.87v61.76Z',
  'm353.34,270.19c.83,11.37,9.39,18.89,21.78,18.89s21.53-7.57,21.53-18.84c0-12.42-7.36-15.53-19.37-19.56l-.16-.06c-4.85-1.67-9.86-3.39-9.86-8.59,0-3.92,3.18-6.76,7.55-6.76s7.27,2.57,8.01,6.82l11.31.06c-.78-10.57-8.21-17.3-19.33-17.3s-19.23,6.96-19.23,16.93c0,8.93,4.5,13.82,16.62,18.06,7.1,2.5,11.75,4.56,11.75,10.15,0,4.77-3.66,8.1-8.9,8.1s-8.57-3.06-9.37-7.92h-12.33Z',
]

// Static NE Group logo with a zoom-in reveal (scale + fade). Matches the
// defenderV2 loader logo — no stroke "writing" animation.
export default function AnimatedLogo({
  color = '#fff',
  scaleFrom = 5, // starting scale before zooming in to 1
  duration = 0.3, // seconds for the zoom-in
}) {
  return (
    <motion.svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 412.36 289.36"
      initial={{ scale: scaleFrom, opacity: 0 }}
      animate={{ scale: 1, opacity: 1 }}
      transition={{ duration }}
      style={{ width: '100%', height: 'auto' }}
    >
      {PATHS.map((d, i) => (
        <path key={i} d={d} fill={color} />
      ))}
    </motion.svg>
  )
}
